import { DraftConfiguration, DraftState, Point } from '@/types';
import { getRandomCid } from '@/model/configuration/getRandomCid';
import { isDraftPlaceholderTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { addConfigurationToDraft } from './helper/addConfigurationToDraft';
import { getOffset } from './helper/getOffset';

const shiftOffset = (offset: Point, [shiftOffsetX, shiftOffsetY]: [number, number]) => ({
  x: offset.x + shiftOffsetX,
  y: offset.y + shiftOffsetY,
});

export const duplicateConfigurationAction =
  (configuration: DraftConfiguration) => (draft: DraftState) => {
    const newCid = getRandomCid();
    const offsetShift = getOffset(configuration.printArea);

    const newConfiguration = {
      ...configuration,
      cid: newCid,
      offset: shiftOffset(configuration.offset, offsetShift),
    };

    if (isDraftPlaceholderTextConfiguration(newConfiguration)) {
      newConfiguration.placeholderCenter = shiftOffset(
        newConfiguration.placeholderCenter,
        offsetShift
      );
    }

    // duplicate the validation errors too
    draft.validation.errors[newCid] = draft.validation.errors[configuration.cid];

    addConfigurationToDraft(draft, newConfiguration);
  };
